import styled from 'styled-components'

export const Checkbox = styled.input`
	position: absolute;
	opacity: 0;
	flex-shrink: 0;
`
